"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permissions = void 0;
var react_1 = __importDefault(require("react"));
var usePermission_1 = __importStar(require("./usePermission"));
function Permission(_a) {
    var children = _a.children, service = _a.service, type = _a.type, field = _a.field, debug = _a.debug;
    var hasPermission = (0, usePermission_1.default)(service, type !== null && type !== void 0 ? type : '*', field !== null && field !== void 0 ? field : '*', debug)[0];
    return react_1.default.createElement(react_1.default.Fragment, null, hasPermission && children);
}
exports.default = Permission;
function Permissions(_a) {
    var children = _a.children, permissions = _a.permissions, _b = _a.needsAll, needsAll = _b === void 0 ? false : _b, debug = _a.debug;
    var _c = (0, usePermission_1.usePermissions)(permissions, debug), _ = _c[0], _d = _c[1], hasAllPermissions = _d.hasAllPermissions, hasAtLeastOnePermission = _d.hasAtLeastOnePermission;
    return (react_1.default.createElement(react_1.default.Fragment, null, ((needsAll && hasAllPermissions) || (needsAll === false && hasAtLeastOnePermission)) &&
        children));
}
exports.Permissions = Permissions;
//# sourceMappingURL=Permission.js.map